import { Box, Typography } from "@mui/material";
import { FinishedExamPageProps } from "../../Utils/Types";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Vocabulary } from "../../Utils/Vocabulary";
import Config from "../../Utils/Config";
import { examCategories } from "../../Utils/Constants";

export default function FinishedExamPage(props: FinishedExamPageProps) {
  const { correctAnswers, wrongAnswers, examCategory } = props;

  // Get max allowed wrong answers for the exam category
  const categoryData =
    examCategories[examCategory as keyof typeof examCategories];
  const maxAllowedWrong =
    categoryData?.maxAllowedWrong || Config.maxWrongExamQuestions;

  // Determine if exam passed or failed
  const isPassed = wrongAnswers < maxAllowedWrong;

  return (
    <Box
      width="100%"
      height="82vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box mb={4}>
        {isPassed ? (
          <CheckCircleIcon sx={{ fontSize: 80, color: "green" }} />
        ) : (
          <CancelIcon sx={{ fontSize: 80, color: "red" }} />
        )}
      </Box>

      <Typography
        variant="h4"
        color={isPassed ? "success.main" : "error"}
        sx={{ textAlign: "center", fontWeight: 500 }}
      >
        {isPassed ? Vocabulary.passedExamText : Vocabulary.failedExamText}
      </Typography>

      <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
        <Typography variant="h6" color="success.main" mb={1}>
          {`${Vocabulary.correctAnswers}: ${correctAnswers}`}
        </Typography>
        <Typography variant="h6" color="error.main">
          {`${Vocabulary.wrongAnswers}: ${wrongAnswers}`}
        </Typography>
      </div>
    </Box>
  );
}
